module.exports = __webpack_public_path__ + "img/logo-scmobi-white.3b247bed.svg";